module.exports = __webpack_public_path__ + "img/index-s3.23cc6a7a.png";